import axios from 'axios';
import { storageService } from './StorageService';
import { errorService } from './ErrorService';

let refreshTokenPromise = null;

const onRefreshToken = async () => {
  if (!refreshTokenPromise) {
    const refreshToken = await storageService.getItem('refreshToken');
    if (!refreshToken) return null;

    refreshTokenPromise = axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/v1/auth/refresh`,
        {},
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        }
      )
      .then((response) => {
        const { token, refreshToken: newRefreshToken } = response.data;
        storageService.setItem('accessToken', token);
        storageService.setItem('refreshToken', newRefreshToken);
        return token;
      })
      .catch(async (error) => {
        errorService.send(error);
        await storageService.removeItem('accessToken');
        await storageService.removeItem('refreshToken');
        window.location.href = '/auth/onboarding';
        throw error;
      })
      .finally(() => {
        refreshTokenPromise = null;
      });
  }

  return refreshTokenPromise;
};

const createApiInstance = (baseURL) => {
  const instance = axios.create({ baseURL });

  // Добавляем CancelToken
  instance.getSource = () => {
    return axios.CancelToken.source();
  };

  instance.interceptors.request.use(
    async (config) => {
      const token = await storageService.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retried) {
        const refreshToken = await storageService.getItem('refreshToken');
        if (!refreshToken) return Promise.reject(error);

        originalRequest._retried = true;
        try {
          const newToken = await onRefreshToken();
          if (!newToken) return Promise.reject(error);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return instance(originalRequest);
        } catch (e) {
          return Promise.reject(e);
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export const apiService = createApiInstance(process.env.REACT_APP_API_URL);
export const chatApiService = createApiInstance(process.env.REACT_APP_API_CHATS_URL);
